import { useQuery } from '@tanstack/react-query';
import {
  fetchRangeSafetyEvents,
  sortSafetyEventsByTimestamp,
  type SafetyEvent,
} from '@apis/reports';

interface Params {
  siteId: string;
  startTimestamp: number;
  endTimestamp: number;
  areaId?: string;
  floorId?: string;
}

export function useSafetyEventsInRangeQuery(params: Params) {
  const enabled =
    !!params.siteId && params.startTimestamp > 0 && params.endTimestamp > params.startTimestamp &&
    (!!params.areaId || !!params.floorId);
  return useQuery<SafetyEvent[]>({
    queryKey: [
      'reports', 'observe-location', 'safety-events',
      params.siteId, params.startTimestamp, params.endTimestamp,
      params.areaId ?? '', params.floorId ?? '',
    ] as const,
    queryFn: ({ signal }) => fetchRangeSafetyEvents(params, signal),
    // Chronological order — the panel reads events in display order
    // matching the ObserveLocation timeline.
    select: sortSafetyEventsByTimestamp,
    enabled,
    staleTime: 5 * 60_000,
  });
}
